import React, { useState, useEffect } from 'react';
import shareIcon from '../../assets/ShareIcon.svg';
import closeIcon from '../../assets/CloseIcon.svg';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs'; 
import { useSearchTextContext } from '../../context/SearchTextContext';  
import { isMobile } from 'react-device-detect';
import BackIcon from "../../assets/BackIcon.svg"
import SendIcon from "../../assets/SendIcon.svg"
import { showMessage } from '../../languages/_showmessages';
import { useSearchContext } from '../../context/SearchContext';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';

interface SearchBoxProps {
  isSearch: boolean;
  setIsSearch: React.Dispatch<React.SetStateAction<boolean>>;
  isSearchBoxVisible: boolean;
  setIsSearchBoxVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const SearchBox: React.FC<SearchBoxProps> = ({ isSearch, setIsSearch, isSearchBoxVisible, setIsSearchBoxVisible }) => {    
  const { SearchText, setSearchText } = useSearchTextContext();
  const [ searchTextTmp, setSearchTextTmp ] = useState<string>('');
  const { Search, setSearch } = useSearchContext();
  const [ showNotification, setShowNotification ] = React.useState(false);

  useEffect(() => {
    if (Search === null || Search === undefined) return;

    setIsSearchBoxVisible(false); // Mobile only
    setIsSearch(true);
    setSearchTextTmp(SearchText || '');
  }, [Search]);
  
  const clear = () => {
    setIsSearch(false);
    setSearchTextTmp('');
    setSearchText('');
    setSearch(null);
  };

  const SearchCmd = async () => {
    if (searchTextTmp === '') return; 
    setSearchText(searchTextTmp);
  }
        
  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      SearchCmd();
    }
  }  
  
  const copy2clipboard = () => {
    const paths : string[] = window.location.pathname.split("/");
    const url : string = window.location.origin + "/" + paths[1] + "/search/" + SearchText ;

    navigator.clipboard.writeText(url);
    setShowNotification(true);
    setTimeout(()=>{setShowNotification(false)},2000)
  };

  return (
    <>
      {isMobile ?
        isSearchBoxVisible ?
          <div className="searchbox-mobile">
            <div onClick={() => setIsSearchBoxVisible(false)} className="close-searchBox">
              <img src={BackIcon} className='backicon-mobile' alt="back" />
            </div>
            <div className='searchmiddle-mobile'>
              <div>
                <Input autoFocus={true} className='searchinput-mobile' value={searchTextTmp} onKeyDown={handleKeyDown} onChange={(e) => { setSearchTextTmp(e.value); }} />
              </div>
            </div>
            <div className='left'>
              {isSearch ? 
                <div onClick={clear} className='searchclear-mobile' title='Limpa a pesquisa'>
                  <img src={closeIcon} className='searchshareandclearbtn' alt="close" onClick={() => {clear()}} title={showMessage("limpaaPesquisa")}/>
                </div>
              : 
                <></> 
              }
              <div className='left' onClick={SearchCmd}>
                <img className='sendicon-mobile' src={SendIcon} alt="search" />
              </div>
            </div>
          </div>
        :
          <></>
      :
        <div className='searchbox'>
          <div className='left'>
            <Input placeholder={showMessage("pesquisarNasBibliotecas")} title={showMessage("pressioneEnterParaPesquisar")} className='searchinput' value={searchTextTmp} onKeyDown={handleKeyDown} onChange={(e) => {setSearchTextTmp(e.value); }} />
          </div>
          <div className='left'>
            {isSearch ? 
              <div className='searchcleardiv'>
                <img src={shareIcon} className='searchshareandclearbtn' alt="share" onClick={() => {copy2clipboard()}} title={showMessage("copysearchurl")}/>
                <img src={closeIcon} className='searchshareandclearbtn' alt="close" onClick={() => {clear()}} title={showMessage("limpaaPesquisa")}/>
              </div> 
            :
              <></>
            }
            <Button title={showMessage("cliqueParaPesquisar")} onClick={SearchCmd}  className='searchbutton'>{showMessage("pesquisar")}</Button>
          </div>        
        </div>          
      }

      <NotificationGroup style={{backgroundColor: '#b51e26ce', top: '30px', left: '50%', zIndex: '10'}}>
        <Fade>
          {showNotification && <Notification type={{style: 'info', icon: false}} closable={false}>
          <span>{showMessage("copiedurl")}</span>
          </Notification>}
        </Fade>
      </NotificationGroup>
    </>
  );
};

export default SearchBox;